import { ActionTypes, EnumActionsTypes } from './message.redux.types';
import { mapCodes } from '../../../services/http/http.codes';

export const showMessage = (
  statusCode: string,
  customCode: string,
  setType?: string,
  setText?: string,
): ActionTypes => {
  const defaultType = setType || 'danger';
  const defaultText =
    setText ||
    'Ocurrió un error. Por favor contacta a ayuda@creditas.com para apoyarte a obtener tu crédito.';
  const type =
    mapCodes[statusCode] && mapCodes[statusCode][customCode]
      ? mapCodes[statusCode][customCode].type
      : defaultType;
  const message =
    mapCodes[statusCode] && mapCodes[statusCode][customCode]
      ? mapCodes[statusCode][customCode].message
      : defaultText;
  const newPayload = {
    code: statusCode,
    type,
    message,
  };
  return {
    type: EnumActionsTypes.SHOW_MESSAGE,
    payload: newPayload,
  };
};

export const hideMessage = (): ActionTypes => ({
  type: EnumActionsTypes.HIDE_MESSAGE,
});
